module.exports = __webpack_public_path__ + "83e56e13ab80efe1e90c20d5584b007a.svg";